import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { setShowMessage } from "../redux/slices/notificationSlice";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation, useNavigate } from "react-router-dom";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import { Button, Row, Col } from "react-bootstrap";
import downloadgif from "../assets/images/download.gif";
import DownloadIcon from "@mui/icons-material/Download";
import translations from "../assets/locals/translations";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { TextField, MenuItem, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import {
  clearEditagencyData,
  clearEditagencyState,
  editagencyUpdateToDb,
} from "../redux/slices/editAgencySlice";
import Branch from "./Branch";
import { getAllManufacturerAction } from "../components/Master/Manufacturer/getEditeManufacturer";
import { fetchFile } from "../utils/fetchFile";
import {
  addAgencyToDb,
  clearaddaddAgency,
} from "../redux/slices/addagencySlice";
import AgencyProfileService from "../services/agencyProfileService";
export default function Profile_list({ workFor }) {
  const [agencyData, setAgencyData] = useState({
    name: "",
    contact: "",
    email: "",
    logo: null, // or an empty string
    manufacture: "",
    whatsapp_appkey: "",
    whatsapp_authkey: "",
  });
  const [allMfacturerData, setAllMfacturerData] = useState([]);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [filename, setFilename] = useState(null);
  const [profileUrl, setProfileUrl] = useState("");
  const [isAgency, setIsAgency] = useState(false);
  const fileInputRef = useRef(null); // Create a ref for the file input
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addAgency = useSelector((state) => state.addAgency.addAgency);
  const [loading, setLoading] = useState(false);

  function clearInpHook() {
    setAgencyData({
      name: "",
      contact: "",
      email: "",
      logo: null,
      whatsapp_appkey: "",
      whatsapp_authkey: "",
      manufacture: "",
    });
    fileInputRef.current.value = "";
  }

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .max(50, "Name cannot exceed 50 characters"),
    contact: Yup.string()
      .required("Contact person is required")
      .max(50, "Contact person cannot exceed 50 characters"),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email format"),
    whatsapp_appkey: Yup.string()
      .required("App Key is required")
      .max(100, "App Key cannot exceed 100 characters"),
    whatsapp_authkey: Yup.string()
      .required("Auth Key is required")
      .max(270, "Auth Key cannot exceed 270 characters"),
    manufacture: Yup.string().required("Please select a manufacturer"),
  });

  const { editagencySliceState } = useSelector(
    (state) => state.editAgencyDataState
  );

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger file input click using ref
    }
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    console.log(file, "**********");
    if (file) {
      setPreview(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Set the image preview
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };
  const currentLanguage = useSelector((state) => state.language.language);
  // const editagencyData = useSelector(
  //   (state) => state.editAgencyDataState.editagencyData
  // );

  useEffect(() => {
    if (addAgency.isSuccess) {
      if (addAgency.message.isSuccess) {
        dispatch(setShowMessage("Agency is created successfully"));
        dispatch(clearaddaddAgency());
        navigate("/administration/configuration");
        clearInpHook();
        clearaddaddAgency();
      } else {
        dispatch(setShowMessage("Something is wrong"));
      }
    }
  }, [addAgency]);

  useEffect(() => {
    if (editagencySliceState.isSuccess) {
      const result = editagencySliceState.message.result;
      if (result === "success") {
        dispatch(setShowMessage("Changes updated successfully"));
        dispatch(clearEditagencyState());
      } else {
        console.log("Something is wrong!");
        dispatch(setShowMessage("Something is wrong!"));
      }
    }
  }, [editagencySliceState]);

  useEffect(() => {
    if (agencyData) {
      const logo = `${process.env.REACT_APP_NODE_URL}/api/${agencyData.logo}`;
      console.log(logo, "logo");
    }
  }, [agencyData]);

  const loadAgencyImage = async (filename) => {
    console.log(filename, "LOOOOOOOOOOOOOO");
    setFilename(filename);
    const imageUrl = await fetchFile(filename);
    setProfileUrl(imageUrl);
  };

  async function getagencyid() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/agency/get-agencybyid`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    try {
      const response = await Axios.get(url, config);
      if (response.data?.isSuccess) {
        const agencyaary = response.data.result;
        const jsonObject = {};

        agencyaary.forEach((item) => {
          jsonObject[item.key_name] = item.value;
        });
        const jsonOutput = JSON.stringify(jsonObject);

        const parsedJson = JSON.parse(jsonOutput);
        setAgencyData({
          name: parsedJson.name,
          contact: parsedJson.contact,
          email: parsedJson.email,
          manufacture: parsedJson.manufacture,
          whatsapp_appkey: parsedJson.whatsapp_appkey,
          whatsapp_authkey: parsedJson.whatsapp_authkey,
        });
        setIsAgency(response.data?.isAgency);
        await loadAgencyImage(parsedJson.logo);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getagencyid();
  }, []);

  const onChangeHandler = (e) => {
    const { name, value, files } = e.target;
    if (name === "logo") {
      setAgencyData((prevState) => ({
        ...prevState,
        [name]: files[0],
      }));
    } else {
      setAgencyData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const updateFavicon = (faviconURL) => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = faviconURL;
  };

  const handleSubmit = async (values) => {
    setLoading(true); // Start loading

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("contact", values.contact);
    formData.append("email", values.email);
    formData.append("appKey", values.whatsapp_appkey);
    formData.append("authKey", values.whatsapp_authkey);
    formData.append("manufacture", values.manufacture);

    if (preview) {
      formData.append("logo", preview); // Add image to form data
    }

    const agencyService = new AgencyProfileService();

    try {
      const response = await agencyService.agencyProfile(formData);

      if (response.isSuccess) {
        dispatch(setShowMessage(response.result));

        if (workFor === "forAdd") {
          document.title = values.name || "New keshav Tractors" || "CRM Pro"; // Ensure title update
          navigate("/administration/configuration");
        }

        // Set the favicon dynamically if a logo is uploaded
        if (preview) {
          const logoURL = URL.createObjectURL(preview);
          updateFavicon(logoURL);
        }
      } else {
        dispatch(setShowMessage(response.message || "Please select a file to upload."));
      }
    } catch (error) {
      console.error("Error:", error);
      dispatch(setShowMessage("An error occurred while submitting."));
    } finally {
      setLoading(false); // Stop loading after response
    }
  };


  function handlCancel() {
    navigate("/administration/configuration");
  }

  const redirectModal = () => {
    navigate(-1);
  };
  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = profileUrl;
    a.download = filename; // Specify the filename
    a.click(); // Trigger the download
    URL.revokeObjectURL(profileUrl); // Clean up the object URL
  };

  const getManufacturers = () => {
    getAllManufacturerAction()
      .then((data) => {
        setAllMfacturerData(data.result);
      })
      .catch((error) => {
        console.error("Error in getAllStateAction:", error);
      });
  };
  useEffect(() => {
    getManufacturers();
  }, []);
  return (
    <div>
      <div className="bg-white rounded p-0">
        <div className="">
          {workFor === "forEdit" ? (
            <ul
              className="nav nav-pills mb-3 justify-content-center justify-content-md-start "
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  {translations[currentLanguage].agencyp}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  {translations[currentLanguage].branch}
                </button>
              </li>
            </ul>
          ) : (
            <div className="d-flex align-items-center justify-content-between mx-3">
              <h5 className="m-0">{translations[currentLanguage].agency}</h5>
              <Button
                variant="outline-secondary"
                className="text-muted m-1"
                onClick={() => {
                  navigate(-1);
                }}
              >
                {translations[currentLanguage].back}
              </Button>
            </div>
          )}
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div className="container">
                <Formik
                  enableReinitialize={true}
                  initialValues={agencyData}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    handleSubmit(values);
                  }}
                >
                  {({ setFieldValue, isSubmitting }) => (
                    <Form>
                      <Row className="mb-3">
                        {/* Left Column with Input Fields */}
                        <Col md={8}>
                          <Row>
                            <Col md={6}>
                              <label htmlFor="name" className="form-label">
                                {translations[currentLanguage].name}
                              </label>
                              <Field
                                type="text"
                                name="name"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="name"
                                component={({ children }) => (
                                  <span
                                    style={{
                                      color: "darkred",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    {children}
                                  </span>
                                )}
                              />
                            </Col>

                            <Col md={6}>
                              <label htmlFor="contact" className="form-label">
                                {translations[currentLanguage].person}
                              </label>
                              <Field
                                type="text"
                                name="contact"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="contact"
                                component={({ children }) => (
                                  <span
                                    style={{
                                      color: "darkred",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    {children}
                                  </span>
                                )}
                              />
                            </Col>

                            <Col md={6} className="mt-3">
                              <label htmlFor="email" className="form-label">
                                {translations[currentLanguage].email}
                              </label>
                              <Field
                                type="email"
                                name="email"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="email"
                                component={({ children }) => (
                                  <span
                                    style={{
                                      color: "darkred",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    {children}
                                  </span>
                                )}
                              />
                            </Col>

                            <Col md={6} className="mt-3">
                              <label
                                htmlFor="manufacture"
                                className="form-label"
                              >
                                {translations[currentLanguage].selectmanufacturer}
                              </label>
                              <Field
                                as="select"
                                name="manufacture"
                                className="form-select"
                              >
                                <option value="">{translations[currentLanguage].selectmanufacturer}</option>
                                {allMfacturerData.map((man) => (
                                  <option
                                    key={man.manufacturerId}
                                    value={man.manufacturerId}
                                  >
                                    {man.manufacturerName}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="manufacture"
                                component={({ children }) => (
                                  <span
                                    style={{
                                      color: "darkred",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    {children}
                                  </span>
                                )}
                              />
                            </Col>
                          </Row>
                        </Col>

                        {/* Right Column with Profile Picture */}
                        <Col
                          md={4}
                          className="d-flex align-items-center justify-content-center"
                        >
                          <div>
                            {profileUrl && !image ? (
                              <img
                                src={profileUrl}
                                alt="Profile"
                                onClick={handleIconClick}
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : image ? (
                              <img
                                src={image}
                                alt="User Preview"
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <CorporateFareIcon
                                style={{
                                  fontSize: "150px",
                                  cursor: "pointer",
                                  border: "1px solid grey",
                                }}
                                onClick={handleIconClick}
                              />
                            )}
                            <p className="text-muted text-center">
                              {translations[currentLanguage].agencypicture}{" "}
                              {profileUrl && !image && (
                                <IconButton onClick={handleDownload}>
                                  <GetAppIcon fontSize="medium" />
                                </IconButton>
                              )}
                            </p>
                            <input
                              type="file"
                              ref={fileInputRef}
                              accept="image/*"
                              onChange={(event) => {
                                handleImageChange(event);
                                setFieldValue("logo", event.target.files[0]);
                              }}
                              className="form-control"
                              style={{ display: "none" }}
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* WhatsApp Configuration Section */}
                      <Row className="mb-0">
                        <Col>
                          <h7 className="mx-1">   {translations[currentLanguage].configurewhatsapp}</h7>
                          <Tooltip title="Config">
                            <IconButton size="small" color="info">
                              <InfoIcon />
                            </IconButton>
                          </Tooltip>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} className="mt-1">
                          <label className="myLabel" htmlFor="whatsapp_appkey">
                            {translations[currentLanguage].appkey}
                          </label>
                          <Field
                            type="text"
                            name="whatsapp_appkey"
                            className="myInput inputElement form-control"
                            autoComplete="off"
                          />
                          <ErrorMessage
                            name="whatsapp_appkey"
                            component={({ children }) => (
                              <span
                                style={{
                                  color: "darkred",
                                  fontSize: "0.875rem",
                                }}
                              >
                                {children}
                              </span>
                            )}
                          />
                        </Col>

                        <Col md={6} className="mt-2">
                          <label className="myLabel" htmlFor="whatsapp_authkey">
                            {translations[currentLanguage].authkey}
                          </label>
                          <Field
                            type="text"
                            name="whatsapp_authkey"
                            className="myInput inputElement form-control"
                            autoComplete="off"
                          />
                          <ErrorMessage
                            name="whatsapp_authkey"
                            component={({ children }) => (
                              <span
                                style={{
                                  color: "darkred",
                                  fontSize: "0.875rem",
                                }}
                              >
                                {children}
                              </span>
                            )}
                          />
                        </Col>
                      </Row>
                      {/* Submit and Cancel Buttons */}
                      <section className="d-flex mt-3 flex-column flex-sm-row pb-3">
                        <Button
                          variant="outline-secondary"
                          className="m-1 px-5"
                          type="submit"
                        // disabled={isSubmitting}
                        >
                          {workFor === "forEdit"
                            ? translations[currentLanguage].savechanges
                            : isAgency
                              ? translations[currentLanguage].update
                              : translations[currentLanguage].create}
                        </Button>
                        {workFor !== "forEdit" && (
                          <Button
                            variant="outline-secondary"
                            className="m-1 px-4"
                            onClick={redirectModal}
                          >
                            {translations[currentLanguage].cancel}
                          </Button>
                        )}
                      </section>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div>
                <Branch workFor="branch" hideBackButton={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
